import { render } from "./PaginationContent.vue?vue&type=template&id=64bbc220&ts=true"
import script from "./PaginationContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/pagination/PaginationContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64bbc220"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64bbc220', __exports__)) {
    api.reload('64bbc220', __exports__)
  }
  
  module.hot.accept("./PaginationContent.vue?vue&type=template&id=64bbc220&ts=true", () => {
    api.rerender('64bbc220', render)
  })

}


export default __exports__